module.exports = __webpack_public_path__ + "1c5943a17297f7d9c75b8016a6fb5d3b.png";